import { useAction } from "@/hooks/shared";
import { validateInvitationHandler } from "@/services";

export const useValidateInvitation = () => useAction(validateInvitationHandler);
